import xs from "xstream"
import dropRepeats from 'xstream/extra/dropRepeats'
import flattenConcurrently from 'xstream/extra/flattenConcurrently'
import {propOr, eqProps} from 'ramda'

import Loading from './Loading'
import Login from './Login'
import Policy from './Policy'
import Top from './Member/Top'
import MemberId from './Member/MemberId'
import PhotoUpload from './Member/PhotoUpload'

import Forgot from "./Forgot"
import Password from "./Member/Password"
import Profile from "./Member/Profile"
import { ModifyComplete } from "./Member/Profile"

import AddressForm from "./Member/Profile/Address"
import { AddressConfirm } from "./Member/Profile/Address"
import BaseForm from "./Member/Profile/Base"
import { BaseConfirm } from "./Member/Profile/Base"
import WorkForm from "./Member/Profile/Work"
import { WorkConfirm } from "./Member/Profile/Work"
import WithdrawalForm from "./Member/Profile/Withdrawal"
import { WithdrawalConfirm } from "./Member/Profile/Withdrawal"
import RecessForm from "./Member/Profile/Recess"
import { RecessConfirm } from "./Member/Profile/Recess"
import MailForm from "./Member/Mail"

import { ModalDialog } from "../drivers/messageDialog"

import {dumper} from '../utils'
import { VNode, div, footer, h, p, a } from "@cycle/dom"
import { COPYRIGHT } from "../constant"

const ROUTES = {
	'/': Loading,
	'/login': Login,
	'/policy': Policy,
	'/member/top': Top,
	'/forgot': Forgot,
	'/member/password': Password, 
	'/member/mail': MailForm, 
	'/top': MemberId, 
	'/member/photo': PhotoUpload,
  "/member/profile": Profile,
  "/member/profile/complete": ModifyComplete,
  "/member/profile/complete2": ModifyComplete,
  "/member/profile/address": AddressForm,
  "/member/profile/address/confirm": AddressConfirm,
  "/member/profile/base": BaseForm,
  "/member/profile/base/confirm": BaseConfirm,
  "/member/profile/work": WorkForm,
  "/member/profile/work/confirm": WorkConfirm,
  "/member/profile/recess": RecessForm,
  "/member/profile/recess/confirm": RecessConfirm,
  "/member/profile/withdrawal": WithdrawalForm,
  "/member/profile/withdrawal/confirm": WithdrawalConfirm,
};

export const main = (sources: any) => {
	const propOrNever$ = (page$, key) => page$.map(propOr(xs.never(), key)).flatten()
	const equalPaths = eqProps('path')
	const callComponent = sources => ({path, value}) => {
		return value(Object.assign({}, sources, {router: sources.router.path(path)}));
	}
	const page$ = sources.router.define(ROUTES) 
  // .debug(r => console.log(r))
		.filter(({path}) => path)
		.compose(dropRepeats(equalPaths))
		.map(callComponent(sources))
		.remember()
	/* COMM ERROR */
	const commError$ = sources.HTTP
		.select()
		.map(resp$ => resp$.replaceError(() => xs.of({body: {message:"通信エラー", status: -5}})))
		.compose(flattenConcurrently)

	const errMsg$ = commError$
		.filter(({body}) => body.status < -1)
		.map(({body}) => body.message)

	// const route$ = commError$
	// 	.filter(({body}) => body.status == -5)
	// 	.mapTo("/loading")

	const homeRoute$ = sources.DOM.select(".header").events("click").mapTo({href: "http://www.jsrm.or.jp"})

  const modalDialog = ModalDialog(sources)
  // console.log(modalDialog)
	const dom$ = xs.combine(propOrNever$(page$, 'DOM'), modalDialog.DOM as any, sources.loading.dom$)
		.map(([mainView, modalDialog, loading]: [VNode, VNode,  VNode | null]) => {
			return div(".container", [
        div(".header"),
				mainView,
				h("footer", {class: {footer:true}},[
					div(".container",[p([COPYRIGHT])])
				]),
        modalDialog,
        loading,
			])
		})

	return {
		// DOM: propOrNever$(page$, 'DOM') as any,
		DOM: dom$,
		HTTP: propOrNever$(page$, 'HTTP') as any,
		router: propOrNever$(page$, 'router').startWith("/") as any,
		state: propOrNever$(page$, 'state') as any,
		externalLink: xs.merge(propOrNever$(page$, 'externalLink') as any, homeRoute$),
		MSG: xs.merge(propOrNever$(page$, 'MSG'), errMsg$) as any,
		loading: propOrNever$(page$, 'loading') as any,
		ImageLoader: propOrNever$(page$, 'ImageLoader') as any,
		localConfig : propOrNever$(page$, 'localConfig') as any,
		receiptDownload: propOrNever$(page$, 'receiptDownload') as any,
		dumper: propOrNever$(page$, 'dumper') as any,
	}
}
